export default "__VITE_ASSET__CU_B7nHJ__"